import { Box, Modal, Typography } from "@mui/material";
import { Form, Formik } from "formik";
import { useState } from "react";
import * as yup from "yup";
import useAPI from "../../../../api/hooks/useAPI";
import useColors from "../../../../api/hooks/useColors";
import { Toast } from "../../../../components/Toast";
import TextButton from "../../../../components/buttons/TextButton";
import FormTextField from "../../../../components/forms/FormTextField";

const CopyTenantsToBreezeMSSPModal = ({ open, handleClose }) => {
  const colors = useColors();
  const { copyTenantsToBreezeMSSP } = useAPI();
  const [isLoading, setIsLoading] = useState(false);

  const formInitialValues = {
    sourceMsspId: "",
  };

  const formValidationSchema = yup.object().shape({
    sourceMsspId: yup.string().required("Source MSSP ID is required"),
  });

  const onSubmit = async (values) => {
    setIsLoading(true);

    try {
      await copyTenantsToBreezeMSSP(values.sourceMsspId);
      Toast.success("Tenants copied to Breeze MSSP successfully");
      handleClose();
    } catch (error) {
      Toast.error(
        error?.response?.content || "Failed to copy tenants to Breeze MSSP"
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="copy-tenants-modal-title"
    >
      <Box
        sx={{
          width: 500,
          bgcolor: "background.paper",
          margin: "auto",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          overflowY: "auto",
          borderRadius: "10px",
        }}
      >
        <Box sx={{ width: 420, overflowY: "auto", padding: 2 }}>
          <Typography
            variant="subtitle1"
            sx={{
              marginBottom: 3,
              color: colors.text_primary,
              textAlign: "center",
            }}
          >
            Copy Tenants to Breeze MSSP
          </Typography>

          <Formik
            initialValues={formInitialValues}
            validationSchema={formValidationSchema}
            onSubmit={onSubmit}
            enableReinitialize
          >
            {({ handleSubmit }) => (
              <Form onSubmit={handleSubmit}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    paddingRight: 2,
                  }}
                >
                  <FormTextField
                    label="Source MSSP ID"
                    fieldName="sourceMsspId"
                    required
                    helperText="The MSSP ID to copy all tenants from"
                  />
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    gap: 2,
                    alignItems: "center",
                    marginTop: 3,
                  }}
                >
                  <TextButton
                    onClick={handleClose}
                    disabled={isLoading}
                    loading={isLoading}
                    color="inherit"
                  >
                    Cancel
                  </TextButton>
                  <TextButton
                    onClick={handleSubmit}
                    disabled={isLoading}
                    loading={isLoading}
                    color="primary"
                  >
                    Copy Tenants
                  </TextButton>
                </Box>
              </Form>
            )}
          </Formik>
        </Box>
      </Box>
    </Modal>
  );
};

export default CopyTenantsToBreezeMSSPModal;
